<ng-template #eventSidebarTemplate>
    <div class="top-bar">
        <span>EVENTS</span>
        <ig-button (trigger)="back()" size="md">BACK</ig-button>
    </div>

    <ig-event-filter #eventFilter mode="map" [customEvents]="customEvents"></ig-event-filter>

    <div class="map-view-whole-list" [ngClass]="{'map-view-whole-list-height':showingCount}">
        <div *ngIf="(!events||!events.length)&&!isLoading" class="no-content">No Content Here</div>
        <div class="map-view-list-wrap" *ngFor="let event of events; let i = index"
            (mouseenter)="showInfoWindowByIndex(i)" (click)="showDetails(event._id)" matTooltip="Click to See Details">
            <ig-row>
                <ig-col [xs]="8">
                    <div class="map-view-list-title">{{event.title||event.name}}</div>
                    <div class="map-view-list-info">
                        <ig-row>
                            <ig-col [xs]="1">
                                <mat-icon>room</mat-icon>
                            </ig-col>
                            <ig-col [xs]="11">{{event.isOnlineEvent ? 'Online Event' : (event.address?.address||event.address||'(no location)')}}</ig-col>
                        </ig-row>
                    </div>
                    <div class="map-view-list-info">
                        <ig-row>
                            <ig-col [xs]="1">
                                <mat-icon>date_range</mat-icon>
                            </ig-col>
                            <ig-col [xs]="11">
                                {{(event.eventTimes&&event.eventTimes.length>1)?'Multiple Dates, ':''}}
                                <span>{{event.startTimeFormatted}}{{event.endTimeFormatted?' -
                                    '+event.endTimeFormatted:''}}</span>
                            </ig-col>
                        </ig-row>
                    </div>
                </ig-col>
                <ig-col [xs]="4" class="map-view-list-img-warp relative">
                    <ig-image [imageUrl]="event.cover?.source" [alt]="event.title||event.name"></ig-image>
                    <div class="choice-label" *ngIf="event.isChoice">
                        <mat-icon>favorite</mat-icon>
                    </div>
                </ig-col>
            </ig-row>
        </div>
    </div>
    <div *ngIf="showingCount" class="results map-view-list-info" [ngClass]="{'result-height':showingCount}">
        Showing results {{showingCount}} <span [ngClass]="{'no-more':noMoreBack}"
            (click)="pagingBack()"><mat-icon>chevron_left</mat-icon></span>
        <span [ngClass]="{'no-more':noMoreNext}" (click)="pagingNext()"><mat-icon>chevron_right</mat-icon></span>
    </div>
</ng-template>

<div class="event-map">
    <ig-row class="full-height">
        <ig-col [xs]="12" class="side-event-list-col">
            <mat-sidenav-container class="full-height">
                <mat-sidenav #sideBar mode="over">
                    <ig-side-bar (onClose)="sideBar.close()"></ig-side-bar>
                </mat-sidenav>
                <mat-sidenav-content class="full-height">
                    <div class="page-header">
                        <button mat-icon-button (click)="sideBar.open()">
                            <mat-icon>menu</mat-icon>
                        </button>
                        <h1>Events</h1>
                    </div>
                    <div class="ig-container-fluid full-height">
                        <ig-row class="full-height">
                            <ig-col class="stick-side-bar" [xs]="3">
                                <ng-container [ngTemplateOutlet]="eventSidebarTemplate"></ng-container>
                            </ig-col>

                            <ig-col class="content" [xs]="9">
                                <agm-map #map [styles]="hideIconMapStyler"
                                    [ngClass]="{'full-map':isMapFullSize,'half-map':!isMapFullSize}"
                                    [fitBounds]="latLngBounds" [latitude]="lat" [longitude]="lng"
                                    (zoomChange)="mapZoomChange()">
                                    <agm-marker *ngFor="let geo of events; let i = index" #marker [id]="'marker'+i"
                                        [latitude]="geo.address.lat||geo.lat" [longitude]="geo.address.lng||geo.lng"
                                        (mouseOver)="showInfoWindowOnMarker(i)" (mouseOut)="hideInfoWindow(infoWindow)">
                                        <agm-snazzy-info-window [id]="'infoWindow'+i" [isOpen]="isInfoWindowsOpen[i]"
                                            [closeWhenOthersOpen]="true" (afterClose)="hideAllSingleInfoWindow()">
                                            <ng-template>
                                                <div style="position: relative" (mouseenter)="removeDisplayInfoWindow()"
                                                    (mouseleave)="addDisplayInfoWindow()">
                                                    <div class="map-event-title">
                                                        {{geo.title||geo.name}}
                                                    </div>
                                                    <div class="map-event-img">
                                                        <!--                                                        <img [src]="imageService.safeImage(imageService.imageSource(geo))"-->
                                                        <!--                                                             alt="event image">-->
                                                        <ig-image [imageUrl]="imageService.imageSource(geo)"
                                                            alt="event image"></ig-image>
                                                    </div>
                                                    <div class="map-event-time">
                                                        <div *ngIf="geo.eventTimes&&geo.eventTimes.length>1">
                                                            <p *ngFor="let eventTime of geo.eventTimes">
                                                                {{eventTime.startTimeFormatted}}
                                                                {{eventTime.endTimeFormatted?' -
                                                                '+eventTime.endTimeFormatted:''}}
                                                            </p>
                                                        </div>
                                                        <div *ngIf="!geo.eventTimes||geo.eventTimes.length<=1">
                                                            <ng-container>
                                                                {{geo.startTimeFormatted}}
                                                                {{geo.endTimeFormatted?' - '+geo.endTimeFormatted:''}}
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                    <ig-button class="event-btn" (trigger)="showDetails(geo._id)">
                                                        DETAILS
                                                    </ig-button>
                                                </div>
                                            </ng-template>
                                        </agm-snazzy-info-window>
                                    </agm-marker>

                                    <agm-snazzy-info-window #infoWindow [latitude]="groupLat" [longitude]="groupLng"
                                        [isOpen]="showGroupInfowWindow" [closeWhenOthersOpen]="true"
                                        (afterClose)="groupInfoWindowCloses()">
                                        <ng-template>
                                            <div style="position: relative" (mouseenter)="removeDisplayInfoWindow()"
                                                (mouseleave)="addDisplayInfoWindow()">
                                                <div class="map-view-group-wrap map-view-list-wrap"
                                                    *ngFor="let e of groupEvents" (click)="showDetails(e._id)"
                                                    matTooltip="Click to See Details">
                                                    <ig-row>
                                                        <ig-col [xs]="8">
                                                            <div class="map-view-list-title">{{e.title||e.name}}</div>
                                                            <div class="map-view-list-info">
                                                                <ig-row>
                                                                    <ig-col [xs]="1">
                                                                        <mat-icon>date_range</mat-icon>
                                                                    </ig-col>
                                                                    <ig-col [xs]="11">
                                                                        {{(e.eventTimes&&e.eventTimes.length>1)?'Multiple
                                                                        Dates, ':''}}
                                                                        <span
                                                                            *ngIf="e.startTimeText">{{e.startTimeText+'
                                                                            '+e.timezone}}{{e.endTimeText?' -
                                                                            '+e.endTimeText+' '+e.timezone:''}}</span>
                                                                        <span
                                                                            *ngIf="!e.startTimeText">{{e.startTimeFormatted}}{{e.endTimeFormatted?'
                                                                            - '+e.endTimeFormatted:''}}</span>
                                                                    </ig-col>
                                                                </ig-row>
                                                            </div>
                                                        </ig-col>
                                                        <ig-col [xs]="4" class="map-view-list-img-warp">
                                                            <!--                                                            <img class="map-view-list-img"-->
                                                            <!--                                                                 [src]="imageService.safeImage(imageService.imageSource(e))"-->
                                                            <!--                                                                 width="50px" height="40px"-->
                                                            <!--                                                                 alt="event image">-->
                                                            <ig-image [imageUrl]="imageService.imageSource(e)"
                                                                alt="event image"></ig-image>
                                                        </ig-col>
                                                    </ig-row>
                                                </div>
                                            </div>

                                        </ng-template>
                                    </agm-snazzy-info-window>
                                </agm-map>

                                <div class="expand-map" (click)="resizeMap()">
                                    <mat-icon *ngIf="!isMapFullSize">fullscreen</mat-icon>
                                    <mat-icon *ngIf="isMapFullSize">fullscreen_exit</mat-icon>
                                </div>

                                <div class="map-view-whole-list" [ngClass]="{'map-view-mobile':showingCount}">
                                    <div *ngIf="isLoading" class="no-content">loading...</div>
                                    <div *ngIf="((!events||!events.length)&&!isLoading)" class="no-content">No Content
                                        Here
                                    </div>
                                    <div class="map-view-list-wrap" *ngFor="let event of events; let i = index"
                                        (mouseenter)="showInfoWindowByIndex(i)" (click)="showDetails(event._id)"
                                        matTooltip="Click to See Details">
                                        <ig-row>
                                            <ig-col [xs]="8">
                                                <div class="map-view-list-title">{{event.title||event.name}}</div>
                                                <div class="map-view-list-info">
                                                    <ig-row>
                                                        <ig-col [xs]="1">
                                                            <mat-icon>room</mat-icon>
                                                        </ig-col>
                                                        <ig-col [xs]="11">{{event.address?.address||event.address||'(no
                                                            location)'}}
                                                        </ig-col>
                                                    </ig-row>
                                                </div>
                                                <div class="map-view-list-info">
                                                    <ig-row>
                                                        <ig-col [xs]="1">
                                                            <mat-icon>date_range</mat-icon>
                                                        </ig-col>
                                                        <ig-col [xs]="11">
                                                            {{(event.eventTimes&&event.eventTimes.length>1)?'Multiple
                                                            Dates, ':''}}
                                                            <span *ngIf="event.startTimeText">{{event.startTimeText+'
                                                                '+event.timezone}}{{event.endTimeText?' -
                                                                '+event.endTimeText+' '+event.timezone:''}}</span>
                                                            <span
                                                                *ngIf="!event.startTimeText">{{event.startTimeFormatted}}{{event.endTimeFormatted?'
                                                                - '+event.endTimeFormatted:''}}</span>
                                                        </ig-col>
                                                    </ig-row>
                                                </div>
                                            </ig-col>
                                            <ig-col [xs]="4" class="map-view-list-img-warp">
                                                <img class="map-view-list-img"
                                                    [src]="imageService.safeImage(imageService.imageSource(event))"
                                                    width="50px" height="40px" alt="event image">
                                            </ig-col>
                                        </ig-row>
                                    </div>
                                </div>

                                <div *ngIf="showingCount" class="results map-view-list-info"
                                    [ngClass]="{'result-height':showingCount}">
                                    Showing results {{showingCount}} <span [ngClass]="{'no-more':noMoreBack}"
                                        (click)="pagingBack()"><mat-icon>chevron_left</mat-icon></span>
                                    <span [ngClass]="{'no-more':noMoreNext}"
                                        (click)="pagingNext()"><mat-icon>chevron_right</mat-icon></span>
                                </div>
                            </ig-col>
                        </ig-row>
                    </div>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </ig-col>
    </ig-row>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.map/visitor.event.map.component.html